import { BaseApi } from './base';
import type { UserNotification } from './types';

/**
 * API client for in-app notifications
 */
class NotificationsApi extends BaseApi {
  /** Fetch the last 50 non-hidden notifications for the current user */
  async getAll(): Promise<UserNotification[]> {
    return this._request<UserNotification[]>('/notifications');
  }

  /** Get the count of new (unread) notifications */
  async getNewCount(): Promise<{ count: number }> {
    return this._request<{ count: number }>('/notifications/count');
  }

  /** Mark all new notifications as seen */
  async markAllAsSeen(): Promise<void> {
    return this._request<void>('/notifications/seen', { method: 'PATCH' });
  }

  /** Hide (soft-delete) a specific notification */
  async hide(notificationId: string): Promise<void> {
    return this._request<void>(`/notifications/${notificationId}/hide`, {
      method: 'PATCH',
    });
  }
}

export { NotificationsApi };
